/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown> }} Endpoint_Not_Found_DashboardInputs */

const en_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No endpoint in the catalog matches "${i?.path}".`)
};

const zh_hans1_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`目录中没有与“${i?.path}”匹配的接口。`)
};

const pt_br2_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum endpoint do catálogo corresponde a "${i?.path}".`)
};

const es_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ningún endpoint del catálogo coincide con "${i?.path}".`)
};

const fr_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucun endpoint du catalogue ne correspond à « ${i?.path} ».`)
};

const de_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kein Endpoint im Katalog passt zu „${i?.path}“.`)
};

const ru_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В каталоге нет эндпоинта по запросу «${i?.path}».`)
};

const it_endpoint_not_found_dashboard = /** @type {(inputs: Endpoint_Not_Found_DashboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun endpoint del catalogo corrisponde a «${i?.path}».`)
};

/**
* | output |
* | --- |
* | "No endpoint in the catalog matches \"{path}\"." |
*
* @param {Endpoint_Not_Found_DashboardInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_not_found_dashboard = /** @type {((inputs: Endpoint_Not_Found_DashboardInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Not_Found_DashboardInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_not_found_dashboard(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_not_found_dashboard(inputs)
	if (locale === "es") return es_endpoint_not_found_dashboard(inputs)
	if (locale === "fr") return fr_endpoint_not_found_dashboard(inputs)
	if (locale === "de") return de_endpoint_not_found_dashboard(inputs)
	if (locale === "ru") return ru_endpoint_not_found_dashboard(inputs)
	if (locale === "it") return it_endpoint_not_found_dashboard(inputs)
	return en_endpoint_not_found_dashboard(inputs)
});